import { Tag } from "@chakra-ui/tag";
import { GrupoUnidadeItem } from "core/features/grupo-unidades/typings";
import moment from "moment";
import { useMemo } from "react";

function useGrupoUnidadesColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome do grupo",
        render: (original: GrupoUnidadeItem) => <div>{original.nome}</div>,
      },
      {
        title: "Data de criação",
        render: (original: GrupoUnidadeItem) => (
          <div>{moment(original.createdAt).format("DD/MM/YYYY")}</div>
        ),
      },
      {
        title: "Número de unidades",
        render: (original: GrupoUnidadeItem) => (
          <div>
            <Tag variant="outline" colorScheme="blackAlpha">
              {original.numeroUnidades}{" "}
              {original.numeroUnidades === 1 ? "Unidade" : "Unidades"}
            </Tag>
          </div>
        ),
      },
    ];
  }, []);
}

export default useGrupoUnidadesColumns;
